import { TextV2 } from '@dealstack/frontend/shared/components/TextV2/TextV2';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { defaultTheme } from '@dealstack/frontend/shared/mechanism/styleguide/defaultTheme';
import { Radio } from '@mantine/core';
import styled, { css } from 'styled-components';
import { PredefinedIcons } from '@dealstack/frontend/shared/components/fundament/Icon/Icon.types';

interface Props {
	className?: string;
	cardValue: string;
	label: string;
	iconVariant: PredefinedIcons;
	isSelected: boolean;
	noWrap?: boolean;
	onCardClick: () => void;
	disabled?: boolean;
}

const TemplateTypeCard = (props: Props) => {
	const { className, cardValue, label, iconVariant, noWrap, onCardClick, isSelected, disabled } =
		props;

	return (
		<div className={className} onClick={disabled ? undefined : onCardClick}>
			<Radio disabled={disabled} checked={isSelected} value={cardValue} size="xs" />
			<Icon variant={iconVariant} />
			<TextV2 variant="sans/14/600" noWrap={noWrap}>
				{label}
			</TextV2>
		</div>
	);
};

const Styled = styled(TemplateTypeCard)`
	display: flex;
	gap: 0.5rem;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	padding: 0.5rem;
	border-radius: 0.25rem;
	box-sizing: border-box;
	height: 2.25rem;
	background-color: ${defaultTheme.v2.color.white[500]};
	${TextV2},${Icon} {
		color: ${defaultTheme.v2.color.neutral[1100]};
	}
	${Icon} {
		&.svg {
			--size: 1rem;
		}
	}
	${({ isSelected }) =>
		isSelected &&
		css`
			border: solid 1px ${defaultTheme.v2.color.secondary[800]};
			background-color: ${defaultTheme.v2.color.secondary[200]};
		`}
`;

export { Styled as TemplateTypeCard };
